import type { ActivityType, ProductKind } from 'types';
import type { EmbeddedProduct } from 'modules/supplier/products';

export const PRODUCT_DISCOVERY_PAGE_SIZE = 200;

export type ProductDiscoveryPage = {
  count: number;
  results: readonly EmbeddedProduct[];
};

export type ProductDiscoveryRequest = {
  url: 'supplier/products/';
  method: 'GET';
  queryParams: {
    type: ActivityType;
    kind: ProductKind;
    search: string;
    disabled: false;
    page_size: number;
    outlet_or_service_category?: number;
    outlet_or_service_category__vendor?: number;
    provider?: number;
    provided?: true;
  };
};

/** Shared bounded request contract for product-chain discovery. */
export function productDiscoveryRequest({
  type,
  kind,
  search,
  outletOrServiceCategory,
  outletVendor,
  provider,
  provided,
}: {
  type: ActivityType;
  kind: ProductKind | null;
  search: string;
  outletOrServiceCategory?: number;
  outletVendor?: number;
  provider?: number;
  provided?: true;
}): ProductDiscoveryRequest | null {
  if (!kind) return null;

  return {
    url: 'supplier/products/',
    method: 'GET',
    queryParams: {
      type,
      kind,
      search,
      disabled: false,
      page_size: PRODUCT_DISCOVERY_PAGE_SIZE,
      ...(outletOrServiceCategory == null ? {} : { outlet_or_service_category: outletOrServiceCategory }),
      ...(outletVendor == null ? {} : { outlet_or_service_category__vendor: outletVendor }),
      ...(provider == null ? {} : { provider }),
      ...(provided ? { provided: true as const } : {}),
    },
  };
}
